<template>
    <div>
        <v-progress-linear
            :indeterminate="$store.getters.getLoading"
            :value="100"
            color="primary"
            height="7px"
            active
            absolute
            top
        />
        <img
            v-show="$vuetify.breakpoint.smAndUp"
            id="logo"
            alt="logo"
            :src="require('@/assets/logos/ft207_mini_logo.png')"
            @click="bannerClicked()"
        />
    </div>
</template>
<script>
export default {
    methods: {
        bannerClicked() {
            if (this.$store.getters.isAuthenticated) {
                this.$router.push("/");
            }
        },
    },
};
</script>

<style>
img[alt*="logo"] {
    cursor: pointer;
}
#logo {
    margin-top: -10px;
    margin-left: -10px;
    margin-right: 10px;
    height: 45px;
}
</style>
